import { Container, Typography, Box } from '@mui/material'

export default function SolarPricingPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Solar Pricing Tracker
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          This page will display current solar equipment pricing and market trends.
        </Typography>
      </Box>
    </Container>
  )
}